"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState, useEffect, useCallback } from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Erik Johansson",
  quote: "Logik Ekonomi har gett oss den trygghet och personliga service vi letat efter. De är mer än bara en redovisningsbyrå.",
  position: "VD, Fastighetsbolaget",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/avatar_anna_svensson.png"
}, {
  author: "Sarah Nilsson",
  quote: "Smidigt, professionellt och alltid tillgängliga för rådgivning. Rekommenderas varmt för alla småföretagare.",
  position: "Grundare, Designstudion",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/avatar_johan_eriksson.png"
}, {
  author: "Mikael Berg",
  quote: "Deras expertis inom affärssystem och HR har varit avgörande för vår tillväxtresa under det senaste året.",
  position: "Operativ chef",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620476/img/avatar_maria_lindberg.png"
}];
export default function IndustryVoices() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  const scrollPrev = useCallback(() => {
    api?.scrollPrev();
  }, [api]);
  const scrollNext = useCallback(() => {
    api?.scrollNext();
  }, [api]);
  return <section data-section-id="45480" id="röster-från-våra-kunder" ref={ref} className={cn("bg-background text-foreground py-24 lg:py-32 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(circle_at_center,_var(--primary)_0%,_transparent_70%)] opacity-5 blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12 border-b border-border/20 pb-6 flex items-end justify-between">
            <h2 className="text-sm font-mono tracking-widest uppercase text-muted-foreground">
              Röster från våra kunder
            </h2>
            <span className="text-xs font-mono text-muted-foreground/50 hidden sm:block">
              {current.toString().padStart(2, "0")} /{" "}
              {count.toString().padStart(2, "0")}
            </span>
          </div>

          <Carousel setApi={setApi} className="w-full cursor-grab active:cursor-grabbing">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col gap-8 md:gap-12 py-4">
                    <blockquote className="relative">
                      <p className="text-3xl md:text-4xl lg:text-5xl font-serif italic leading-tight text-foreground/90 tracking-tight">
                        &ldquo;{item.quote}&rdquo;
                      </p>
                    </blockquote>

                    <div className="flex items-center gap-4">
                      <SafeHydrate><Avatar className="h-12 w-12 grayscale opacity-80 transition-opacity duration-300 hover:opacity-100 hover:grayscale-0 border border-border/50">
                        <AvatarImage src={item.image} alt={item.author} className="object-cover" />
                        <AvatarFallback className="bg-muted text-muted-foreground text-xs font-mono">
                          {item.author.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex flex-col">
                        <cite className="not-italic text-base font-medium text-foreground tracking-tight">
                          {item.author}
                        </cite>
                        <span className="text-sm text-muted-foreground font-sans uppercase tracking-wider text-[10px]">
                          {item.position}
                        </span>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex items-center justify-between mt-16 pt-8 border-t border-border/10">
            <Button variant="link" onClick={scrollPrev} className="text-muted-foreground hover:text-accent pl-0 text-lg font-serif italic transition-colors duration-300 decoration-accent/30">
              Föregående
            </Button>
            <Button variant="link" onClick={scrollNext} className="text-muted-foreground hover:text-accent pr-0 text-lg font-serif italic transition-colors duration-300 decoration-accent/30">
              Nästa
            </Button>
          </div>
        </div>
      </div>
    </section>;
}